import type { TFunction } from 'i18next';
import type { CategoryMeta } from '@/features/catalog/course';

export function categoryLabel(
  cat: Pick<CategoryMeta, 'slug' | 'name'> & Partial<Pick<CategoryMeta, 'label'>>,
  t: TFunction,
): string {
  return t(`categories.${cat.slug}`, { defaultValue: cat.label ?? cat.name });
}
